// Shared by the detail pages that list related requests (document, email).

// Request status → label and chip colours, matching the Requests page.
export const REQUEST_STATUS = {
  pending: ['Pending', 'amber'],
  processing: ['AI Extraction in Progress', 'sky'],
  extracted: ['Extracted', 'indigo'],
  reviewing: ['Editing Extracted Data', 'orange'],
  pending_approval: ['Waiting for Review', 'violet'],
  in_review: ['In Review', 'sky'],
  approved: ['Request Submitted', 'emerald'],
  rejected: ['Rejected', 'rose'],
  failed: ['Submission Failed', 'rose'],
  completed: ['Submission Successful', 'emerald'],
  cancelled: ['Cancelled', 'slate'],
}
export const TONE_CHIP = {
  amber: 'bg-amber-50 text-amber-700 ring-amber-600/20 dark:bg-amber-400/10 dark:text-amber-300 dark:ring-amber-400/20',
  sky: 'bg-sky-50 text-sky-700 ring-sky-600/20 dark:bg-sky-400/10 dark:text-sky-300 dark:ring-sky-400/20',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20 dark:bg-indigo-400/10 dark:text-indigo-300 dark:ring-indigo-400/20',
  orange: 'bg-orange-50 text-orange-700 ring-orange-600/20 dark:bg-orange-400/10 dark:text-orange-300 dark:ring-orange-400/20',
  violet: 'bg-violet-50 text-violet-700 ring-violet-600/20 dark:bg-violet-400/10 dark:text-violet-300 dark:ring-violet-400/20',
  emerald: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20 dark:bg-emerald-400/10 dark:text-emerald-300 dark:ring-emerald-400/20',
  rose: 'bg-rose-50 text-rose-700 ring-rose-600/20 dark:bg-rose-400/10 dark:text-rose-300 dark:ring-rose-400/20',
  slate: 'bg-gray-100 text-gray-600 ring-gray-500/20 dark:bg-gray-400/10 dark:text-gray-300 dark:ring-gray-400/20',
}
export const TONE_DOT = {
  amber: 'bg-amber-500', sky: 'bg-sky-500', indigo: 'bg-indigo-500', orange: 'bg-orange-500',
  violet: 'bg-violet-500', emerald: 'bg-emerald-500', rose: 'bg-rose-500', slate: 'bg-gray-400',
}
